import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import KeyIcon from "@mui/icons-material/Key";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import axios from "axios";
import Button from "@mui/material/Button";
import { API_PWD_RESET } from "../constants";

function ForgotPasswordReset({ email, setEmail, setPasswordResetFlow }) {
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    if (errorMessage) setErrorMessage("");
  };

  const handlePasswordReset = async () => {
    if (submitting) return;
    if (!email) {
      setErrorMessage("Enter the email address for your account.");
      return;
    }
    setSubmitting(true);
    setErrorMessage("");
    try {
      await axios.post(API_PWD_RESET, { email });
      setPasswordResetFlow(2);
    } catch (error) {
      const status = error?.response?.status;
      if (status === 429) {
        setErrorMessage(
          "Too many reset attempts for this email. Please wait an hour and try again."
        );
      } else {
        setErrorMessage(
          "We couldn't send a reset link right now. Please try again in a few minutes."
        );
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center">
      <div className="w-96 flex flex-col items-center justify-center">
        <div className="h-24 w-24 bg-violet-50 flex items-center justify-center rounded-full">
          <div className="h-16 w-16 bg-violet-100 flex items-center justify-center rounded-full text-violet-700">
            <KeyIcon style={{ fontSize: 40 }} />
          </div>
        </div>
        <div className="mt-5 flex flex-col justify-center items-center">
          <h3 className="text-4xl text-slate-900">Forgot Password?</h3>
          <p className="text-slate-500 mt-4 text-base">
            No worries, we'll send you account access instructions
          </p>
        </div>
        <div className="w-full mt-8">
          <p className="text-slate-500 text-sm">Email Address</p>
          <div className="mt-1.5">
            <TextField
              id="outlined-basic"
              placeholder="email@email.com"
              variant="outlined"
              fullWidth
              value={email}
              onChange={handleEmailChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px !important",
                  height: "55px",
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#6d28d9",
                  },
                  backgroundColor: "white",
                },
              }}
            />
          </div>
          {errorMessage && (
            <p className="text-rose-600 text-sm mt-2">{errorMessage}</p>
          )}
        </div>
        <div className="w-full mt-6">
          <Button
            onClick={handlePasswordReset}
            disabled={submitting}
            fullWidth
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: "50px",
              paddingY: "14px",
              backgroundColor: "#6d28d9",
              "&:hover": {
                backgroundColor: "#5b21b6",
              },
              "&.Mui-disabled": {
                backgroundColor: "#c4b5fd",
                color: "white",
              },
              fontSize: "16px",
            }}
          >
            <span style={{ color: "white" }}>
              {submitting ? "Sending…" : "Reset Password"}
            </span>
          </Button>
        </div>
        <button
          className="mt-4 py-4 px-6 text-slate-500 hover:text-slate-900"
          onClick={() => setPasswordResetFlow(0)}
        >
          <KeyboardBackspaceIcon /> Back to log in
        </button>
      </div>
    </div>
  );
}

export default ForgotPasswordReset;
